import { createRequestActions } from 'src/lib/requestActions';
import { BusinessPartner } from 'src/common/models/businessPartner';

export const businessPartnerActions = createRequestActions(
  `businessPartner/request`,
  `businessPartner/requestSuccess`,
  `businessPartner/requestFailure`
)<string, BusinessPartner, Record<string, unknown>>();
